import loadScript from '~/utils/loadScript'
import host from '~/commun/utils/host'
import { STAMPED_SCRIPT_SRC, STORE_CREDENTIALS } from '~/config'

export default {
  data() {
    return {
      apiKey: null,
      storeUrl: null,
      isBadgesLoaded: false,
    }
  },
  methods: {
    setCredentials() {
      const { storeCode } = this.$store.state
      const {
        stamped: { apiKey, url },
      } = STORE_CREDENTIALS[storeCode] || STORE_CREDENTIALS.br

      this.apiKey = apiKey
      this.storeUrl = url
    },
    loadStampedScript() {
      return loadScript(STAMPED_SCRIPT_SRC)
    },
    initStamped() {
      const { apiKey, storeUrl } = this
      /* istanbul ignore next if */
      if (typeof StampedFn !== 'undefined') {
        window.StampedFn.init({
          apiKey,
          storeUrl: host(storeUrl),
        })
      }
    },
  },
}
